import React from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import { Plus } from "@phosphor-icons/react";

const Breadcrumb = (props) => {
	const navigate = useNavigate();

	// Helper function para lidar com backLink como string ou objeto
	const handleBackLinkClick = () => {
		if (props.backLink) {
			if (typeof props.backLink === 'object') {
				// Para objetos, usar replace para evitar problemas de history
				navigate(props.backLink.pathname, { 
					state: props.backLink.state,
					replace: true 
				});
			} else {
				navigate(props.backLink);
			}
		}
	};

	const styles = {
		breadcrumbContainer: {
			backgroundColor: "#fff",
			borderRadius: "10px",
			padding: "15px",
			minHeight: "65px",
			boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
			width: "100%",
			marginLeft: "2px",
			marginBottom: "15px",
			marginTop: "-10px",
		},
		pageTitleBox: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			width: "100%",
		},
		pageTitleRight: {
			display: "flex",
			alignItems: "center",
		},
		button: {
			// backgroundColor: "#5eb761",
			background: "none",
			padding: "10px",
			color: "black",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: "2px",
			whiteSpace: "nowrap",
		},
		backButton: {
			backgroundColor: "transparent",
			border: "none",
			color: "#000",
			marginRight: "10px",
			display: "flex",
			alignItems: "center",
		},
		title: {
			margin: 0,
			lineHeight: 1,
			fontSize: "18px",
			fontWeight: "bold",
		},
		breadcrumb: {
			display: "flex",
			alignItems: "center",
			marginLeft: "10px",
		},
		breadcrumbItem: {
			color: "#6c757d",
			textDecoration: "none",
			marginRight: "5px",
			fontSize: "14px",
		},
		activeBreadcrumbItem: {
			color: "#000",
			textDecoration: "none",
			fontSize: "14px",
			fontWeight: "bold",
			marginRight: "25px",
			marginLeft: "5px",
		},
	};

	return (
		<Row style={styles.breadcrumbContainer}>
			<div style={styles.pageTitleBox}>
				<div
					className="d-flex align-items-center"
					style={{ cursor: props.backLink ? "pointer" : "default" }}
					onClick={handleBackLinkClick}
				>
					{props.backLink && (
						<Button
							style={styles.backButton}
							onClick={(e) => {
								e.stopPropagation();
								handleBackLinkClick();
							}}
						>
							<i className="bx bx-arrow-back"></i>
						</Button>
					)}
					<h4 className="mb-sm-0" style={styles.title}>
						<span 
							style={{ 
								color: "inherit",
								cursor: props.backLink ? "pointer" : "default"
							}}
							onClick={props.backLink ? handleBackLinkClick : undefined}
						>
							{props.title}
						</span>
					</h4>
				</div>
				<div style={styles.pageTitleRight}>
					{props.title && props.breadcrumbItem && (
						<Col style={styles.breadcrumb}>
							<span style={styles.breadcrumbItem}>
								{props.title}
							</span>
							<span>/</span>
							<span style={styles.activeBreadcrumbItem}>
								{props.breadcrumbItem}
							</span>
						</Col>
					)}
					{props.botao && props.botaoLink && (
						<Col style={{ textAlign: "center" }}>
							<Button
								style={styles.button}
								onClick={() => navigate(props.botaoLink)}
							>
								<Plus size={16} color="black" /> {props.botao}
							</Button>
						</Col>
					)}
					{props.botao && props.onBotaoClick && (
						<Col style={{ textAlign: "center" }}>
							<Button
								style={styles.button}
								onClick={props.onBotaoClick}
							>
								<Plus size={16} color="black" /> {props.botao}
							</Button>
						</Col>
					)}
					{props.extraButton && (
						<Col
							style={{
								textAlign: "center",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								marginLeft: "10px",
							}}
						>
							<Button
								style={{
									backgroundColor:
										props.extraButton.color || "none",
									padding:
										props.extraButton.size || "8px 12px",
									display: "flex",
									alignItems: "center",
									whiteSpace: "nowrap",
									fontSize: "14px",
									background: "none",
									color: "black",
									display: "flex",
									alignItems: "center",
									gap: "2px",
								}}
								onClick={props.extraButton.onClick}
							>
								<i
									className={props.extraButton.icon}
									style={{ margin: 5 }}
								></i>{" "}
								{props.extraButton.label}
							</Button>
						</Col>
					)}
					{props.extraButtonSecondary && (
						<Col
							style={{
								textAlign: "center",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								marginLeft: "10px",
							}}
						>
							<Button
								style={{
									backgroundColor:
										props.extraButtonSecondary.color || "none",
									padding:
										props.extraButtonSecondary.size || "8px 12px",
									display: "flex",
									alignItems: "center",
									whiteSpace: "nowrap",
									fontSize: "14px",
									background: "none",
									color: "black",
									display: "flex",
									alignItems: "center",
									gap: "2px",
								}}
								onClick={props.extraButtonSecondary.onClick}
							>
								<i
									className={props.extraButtonSecondary.icon}
									style={{ margin: 5 }}
								></i>{" "}
								{props.extraButtonSecondary.label}
							</Button>
						</Col>
					)}
				</div>
			</div>
		</Row>
	);
};

Breadcrumb.propTypes = {
	breadcrumbItem: PropTypes.string,
	title: PropTypes.string.isRequired,
	botao: PropTypes.string,
	botaoLink: PropTypes.string,
	onBotaoClick: PropTypes.func,
	backLink: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			pathname: PropTypes.string.isRequired,
		}),
	]),
	extraButton: PropTypes.shape({
		label: PropTypes.string.isRequired,
		icon: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
	}),
	extraButtonSecondary: PropTypes.shape({
		label: PropTypes.string.isRequired,
		icon: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
		color: PropTypes.string,
		size: PropTypes.string,
	}),
};

export default Breadcrumb;
